import type { ImageProps as SurfaceImageProps, SurfaceImageSource } from '@ankhorage/surface';

import type { ZoraBaseProps } from './base';
import type { UploadAsset } from './upload';

export type { ImageFit, SurfaceImageSource } from '@ankhorage/surface';

export interface ImageProps
  extends ZoraBaseProps, Omit<SurfaceImageProps, 'mode' | 'source' | 'themeId'> {
  source?: SurfaceImageSource | UploadAsset | null;
}
